'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/heart/BrokenHeart.tsx
import { jsx } from "react/jsx-runtime";
var BrokenHeart = (props) => /* @__PURE__ */ jsx(
  "svg",
  __spreadProps(__spreadValues({
    width: "48",
    height: "48",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M21.937 11.2842C20.4988 13.1847 19.4353 15.3855 18.6085 17.4399C18.384 17.9976 18.5143 18.6355 18.9394 19.0606L24.2839 24.405L22.577 29.5256C22.315 30.3115 22.7398 31.161 23.5257 31.4229C24.3116 31.6849 25.1611 31.2602 25.4231 30.4743L27.4231 24.4743C27.6027 23.9353 27.4625 23.341 27.0607 22.9393L21.7714 17.6499C22.6503 15.6212 23.7218 13.6812 25.0893 12.1756C27.9116 9.3176 31.1155 8.58968 33.851 9.20111C36.6305 9.82238 39.0697 11.8565 40.2495 14.8057C42.5068 20.4477 40.2728 30.3781 24.0001 39.7738C7.72731 30.3782 5.49333 20.4478 7.75052 14.8057C8.93038 11.8565 11.3695 9.8224 14.149 9.20112C16.5743 8.65904 19.3677 9.16971 21.937 11.2842ZM24 9.09887C27.2798 6.32601 31.0686 5.50517 34.5054 6.27336C38.2851 7.11819 41.5006 9.85617 43.0349 13.6913C46.1725 21.534 42.1743 33.0091 24.7349 42.8078C24.2786 43.0641 23.7217 43.0641 23.2654 42.8078C5.82583 33.0091 1.82756 21.5341 4.96515 13.6914C6.49945 9.8562 9.71488 7.1182 13.4946 6.27337C16.9315 5.50517 20.7203 6.32601 24 9.09887Z",
        fill: "currentColor"
      }
    )
  })
);

// src/heart/FingerHeart.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var FingerHeart = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "67",
    height: "90",
    viewBox: "0 0 67 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx2(
        "path",
        {
          d: "M42.3824 4.42499L12.0274 29.9633C-2.11778 41.8639 -3.96281 63.0085 7.90639 77.1911C19.7756 91.3737 40.8644 93.2236 55.0095 81.323L62.5983 74.9384C67.3134 70.9715 67.3261 63.2037 63.972 59.1958C61.3322 56.0416 54.0837 52.9281 49.2195 57.0204L55.8597 51.4339C60.5747 47.4671 61.1897 40.4189 57.2333 35.6913C53.2769 30.9638 46.2473 30.3472 41.5323 34.314L56.7098 21.5449C61.4249 17.578 62.0399 10.5298 58.0835 5.80229C54.1271 1.07476 47.0975 0.45812 42.3824 4.42499Z",
          fill: "currentColor"
        }
      ),
      /* @__PURE__ */ jsx2(
        "path",
        {
          d: "M9.55121 8.28287C9.34097 7.11783 9.77069 5.92957 10.6784 5.16586L12.3521 3.75775C18.223 -1.18153 26.7755 0.426155 30.7133 6.40008L11.9706 21.6894L9.55121 8.28287Z",
          fill: "currentColor"
        }
      )
    ]
  })
);

// src/heart/Heart.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var Heart = (props) => /* @__PURE__ */ jsx3("svg", __spreadProps(__spreadValues({ width: "16", height: "16", viewBox: "0 0 16 16", xmlns: "http://www.w3.org/2000/svg" }, props), { children: /* @__PURE__ */ jsx3(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3448 4.56385C15.3907 7.1781 14.0579 11.0031 8.2448 14.2693C8.0927 14.3548 7.90706 14.3548 7.75496 14.2693C1.94178 11.0031 0.609025 7.17811 1.65489 4.56387C2.16632 3.28548 3.23813 2.37282 4.49804 2.0912C5.64366 1.83514 6.90659 2.10875 7.99985 3.03304C9.09309 2.10875 10.356 1.83514 11.5016 2.0912C12.7616 2.37281 13.8334 3.28547 14.3448 4.56385Z",
    fill: "currentColor"
  }
) }));

// src/heart/HeartOutlined.tsx
import { jsx as jsx4 } from "react/jsx-runtime";
var HeartOutlined = (props) => /* @__PURE__ */ jsx4(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: /* @__PURE__ */ jsx4(
      "path",
      {
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M16.9255 4.60056C15.5545 4.29413 13.9483 4.6605 12.5347 6.09785C12.3937 6.24121 12.2011 6.32196 12 6.32196C11.7989 6.32196 11.6062 6.24121 11.4653 6.09785C10.0517 4.6605 8.44544 4.29413 7.07448 4.60056C5.68471 4.9112 4.46516 5.92825 3.87523 7.40284C2.74663 10.2239 3.86362 15.1891 12 19.8869C20.1364 15.1891 21.2533 10.2239 20.1247 7.40283C19.5348 5.92824 18.3152 4.91119 16.9255 4.60056ZM21.5174 6.84566C23.0862 10.767 21.0871 16.5045 12.3674 21.4039C12.1393 21.5321 11.8608 21.5321 11.6327 21.4039C2.91289 16.5046 0.913751 10.767 2.48254 6.84568C3.2497 4.9281 4.85741 3.5591 6.74728 3.13668C8.4657 2.75259 10.3601 3.163 12 4.54943C13.6399 3.163 15.5342 2.75258 17.2527 3.13668C19.1425 3.55909 20.7503 4.92809 21.5174 6.84566Z",
        fill: "currentColor"
      }
    )
  })
);

export {
  BrokenHeart,
  FingerHeart,
  Heart,
  HeartOutlined
};
//# sourceMappingURL=chunk-LO6OY5HP.mjs.map